import Cookies from 'js-cookie'

// 往cookie里面存token和username
const LoginKey = 'hasLogin'
// 当前登录的账号
const LoginName = 'CURRENT_NAME'

export function getToken() {
  return Cookies.get(LoginKey)
}

export function setToken() {
  return Cookies.set(LoginKey, '1')
}

export function removeToken() {
  return Cookies.remove(LoginKey)
}
// 用户名cookie
export function removeUsername() {
  return Cookies.remove(LoginName)
}
export function setUsername(username) {
  return Cookies.set(LoginName, username)
}



// WEBPACK FOOTER //
// ./src/utils/auth.js